import { TextInput } from "../../components/Forms/TextField";
import { FormikProvider, useFormik } from "formik";
import * as yup from "yup";
import { Button } from "../../components/Buttons/Button";
import { loginWithWebguid } from "../../utils/api.service";
import { Loader } from "../../components/Loader";
import { useNavigate } from "react-router-dom";
import { toast } from "react-hot-toast";
import queryString from "query-string";

export const Login = () => {
  const navigate = useNavigate();
  const urlParam = queryString.parse(window.location.search);

  const web_guid = urlParam.ref as string;
  const localwebguid = localStorage.getItem("WEB_GUID") ?? "";


  const form = useFormik({
    validationSchema: yup.object({
      username: yup.string().required().label("Username"),
      password: yup.string().required().label("Password"),
    }),
    initialValues: {
      username: "",
      password: "",
    },


    onSubmit: async (values) => {
      try {
        const res = await loginWithWebguid({
          ...values,
          guid: web_guid || localwebguid,
        });
        if (res.data.responseCode === "00") {
          // handleAutoLogout(40000);
          localStorage.setItem("X-PC-ACCESS", res.data.data.auth.accessToken);
          localStorage.setItem("user_data", JSON.stringify(res.data.data));
          localStorage.setItem("WEB_GUID", web_guid);
          navigate("/validate");
        } else {
          toast.error(res.data.responseMessage || "An error occured");
        }
      } catch (error: any) {
        toast.error(error.response.data.responseMessage || "An error occured");
      }
    },
  });
  return (
    <div className="container mx-auto bg-[#1E4A86] h-[100vh]">
      <div className="py-6 flex justify-center">
        <img src="/images/logo.svg" alt="paycentre" />
      </div>

      <div className="rounded-lg bg-white p-8">
        <div className="text-center mb-6">
          <h3 className="text-xl font-bold">Login</h3>
          <p className="">Kindly login to your account</p>
        </div>

        <FormikProvider value={form}>
          <form onSubmit={form.handleSubmit} className="space-y-[28px]">
            <TextInput
              label="Username"
              {...form.getFieldProps("username")}
              context
            />
            <TextInput
              label="Password"
              type="password"
              context
              {...form.getFieldProps("password")}
            />

            {form.isSubmitting ? (
              <div className="flex justify-center">
                <Loader />
              </div>
            ) : (
              <Button btnText="Login" fullWidth />
            )}
          </form>
        </FormikProvider>
      </div>
    </div>
  );
};
